import ShareButtons from '../components/elements/ShareButtons';

if (document.getElementsByClassName('share-buttons-id')) {
  let wl = document.getElementsByClassName('share-buttons-id');

  Array.from(wl).forEach(function (item) {
        new Vue({
          el: item,
          components: {
            ShareButtons
          }
        });
      }
  );
}



// WEBPACK FOOTER //
// ./resources/js/snippets/share_buttons.js